(function Module() {
	'use strict';

	var _ = require('lodash');

	module.exports = {
		histories: [
			{
				code: 'historyOsteoarthritis',
				shortForm: 'Osteoarthritis',
				text: 'Osteoarthritis'
			}, {
				code: 'historyDysplasia',
				shortForm: 'Hip or elbow dysplasia',
				text: 'Hip or elbow dysplasia'
			}, {
				code: 'historyPatella',
				shortForm: 'Luxating patella',
				text: 'Luxating patella'
			}, {
				code: 'historyCoronoid',
				shortForm: 'Coronoid process fracture',
				text: 'Coronoid process fracture'
			}, {
				code: 'historyCranial',
				shortForm: 'Cranial cruciate ligament rupture',
				text: 'Cranial cruciate ligament rupture'
			}, {
				code: 'historySurgery',
				shortForm: 'Joint injury or surgery',
				text: 'Joint injury or surgery'
			}, {
				code: 'historyTickDisease',
				shortForm: 'Lyme disease or other tick-borne disease',
				text: 'Lyme disease or other tick-borne disease'
			}
		],

		states: {
			usa: [
				{code: 'AL', name: 'Alabama'},
				{code: 'AK', name: 'Alaska'},
				{code: 'AZ', name: 'Arizona'},
				{code: 'AR', name: 'Arkansas'},
				{code: 'CA', name: 'California'},
				{code: 'CO', name: 'Colorado'},
				{code: 'CT', name: 'Connecticut'},
				{code: 'DC', name: 'District Of Columbia'},
				{code: 'DE', name: 'Delaware'},
				{code: 'FL', name: 'Florida'},
				{code: 'GA', name: 'Georgia'},
				{code: 'HI', name: 'Hawaii'},
				{code: 'ID', name: 'Idaho'},
				{code: 'IL', name: 'Illinois'},
				{code: 'IN', name: 'Indiana'},
				{code: 'IA', name: 'Iowa'},
				{code: 'KS', name: 'Kansas'},
				{code: 'KY', name: 'Kentucky'},
				{code: 'LA', name: 'Louisiana'},
				{code: 'ME', name: 'Maine'},
				{code: 'MD', name: 'Maryland'},
				{code: 'MA', name: 'Massachusetts'},
				{code: 'MI', name: 'Michigan'},
				{code: 'MN', name: 'Minnesota'},
				{code: 'MS', name: 'Mississippi'},
				{code: 'MO', name: 'Missouri'},
				{code: 'MT', name: 'Montana'},
				{code: 'NE', name: 'Nebraska'},
				{code: 'NV', name: 'Nevada'},
				{code: 'NH', name: 'New Hampshire'},
				{code: 'NJ', name: 'New Jersey'},
				{code: 'NM', name: 'New Mexico'},
				{code: 'NY', name: 'New York'},
				{code: 'NC', name: 'North Carolina'},
				{code: 'ND', name: 'North Dakota'},
				{code: 'OH', name: 'Ohio'},
				{code: 'OK', name: 'Oklahoma'},
				{code: 'OR', name: 'Oregon'},
				{code: 'PA', name: 'Pennsylvania'},
				{code: 'RI', name: 'Rhode Island'},
				{code: 'SC', name: 'South Carolina'},
				{code: 'SD', name: 'South Dakota'},
				{code: 'TN', name: 'Tennessee'},
				{code: 'TX', name: 'Texas'},
				{code: 'UT', name: 'Utah'},
				{code: 'VT', name: 'Vermont'},
				{code: 'VA', name: 'Virginia'},
				{code: 'WA', name: 'Washington'},
				{code: 'WV', name: 'West Virginia'},
				{code: 'WI', name: 'Wisconsin'},
				{code: 'WY', name: 'Wyoming'}
			],
			aus: [
				{code: 'NSW', name: 'New South Wales'},
				{code: 'NT', name: 'Northern Territory'},
				{code: 'QLD', name: 'Queensland'},
				{code: 'SA', name: 'South Australia'},
				{code: 'TAS', name: 'Tasmania'},
				{code: 'VIC', name: 'Victoria'},
				{code: 'WA', name: 'Western Australia'}
			]
		},

		yesNo: [
			{code: 'Y', display: 'Yes'},
			{code: 'N', display: 'No'}
		],

		genders: [
			{code: 'F', display: 'Female', alternate: 'Girl'},
			{code: 'M', display: 'Male', alternate: 'Boy'}
		],

		qolActivities: [
			{
				name: 'Getting Up',
				question: 'Has {{$s.dog.name ? $s.dog.name : "your dog"}}\'s ability to get up from lying down changed in the last 6 months?',
				lowRatingLabel: 'No Problem',
				highRatingLabel: 'Very Difficult',
				model: 'qolGettingUp'
			}, {
				name: 'Pain After Exercise',
				question: 'Does {{$s.dog.name ? $s.dog.name : "your dog"}} show signs of pain the day after a long walk or a lot of exercise?',
				lowRatingLabel: 'None',
				highRatingLabel: 'Quite a Bit',
				model: 'qolPainAfter'
			}, {
				name: 'Activity Level',
				question: 'In the past month, has {{$s.dog.name ? $s.dog.name : "your dog"}} been able to keep up with the activities you enjoy (for example walks, playing, running with you etc.)?',
				lowRatingLabel: 'No Problem',
				highRatingLabel: 'Impossible',
				model: 'qolGeneral'
			}
		],

		activityRatings: [
			{
				rating: 1,
				title: 'No Problem',
				description: 'Not a challenge and can easily be done.'
			}, {
				rating: 2,
				title: 'Mild',
				description: 'You notice there’s a problem, however others may not be able to notice it.'
			}, {
				rating: 3,
				title: 'Moderate',
				description: 'You can easily detect the problem and others can also easily observe it.'
			}, {
				rating: 4,
				title: 'Severe',
				description: 'The problem is very obvious to anyone.'
			}, {
				rating: 5,
				title: 'Impossible',
				description: 'Cannot do the activity at all.'
			}
		],

		lamenessAssessmentRatings: [
			{
				rating: 0,
				description: 'No Lameness'
			}, {
				rating: 1,
				description: 'Mild lameness, lameness difficult to observe; not consistently apparent, dog touched foot to floor on all strides.'
			}, {
				rating: 2,
				description: 'Moderate lameness, consistently apparent, dog touched foot or toe to floor on all strides.'
			}, {
				rating: 3,
				description: 'Severe lameness, marked head nodding, shortened stride, dog touched toe to floor on at least 50% of strides.'
			}, {
				rating: 4,
				description: 'Limited weight bearing lameness, dog touched toe to floor on less than 50% of strides.'
			}, {
				rating: 5,
				description: 'Non weight bearing lameness, dog does not touch toe to floor at any time, or does not move.'
			}
		],

		riskCategories: {
			weight: {
				display: 'Weight',
				icon: 'scale'
			},
			breed: {
				display: 'Breed',
				icon: 'severed-dog-head'
			},
			age: {
				display: 'Age',
				icon: 'cupcake'
			},
			history: {
				display: 'History',
				icon: 'calendar'
			},
			qualityOfLife: {
				display: 'Activity',
				icon: 'paws'
			}
		},

		riskLevels: {
			USA: {
				none: {
					minimumRiskScore: 0,
					display: 'No Risk',
					productRecommendation: 'no recommendation at this time',
					message: '<p>Good news! Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHisHer %> joint health is fine. ' +
						'Let\'s keep it that way! Make sure <%= dogPronounHeShe %> eats a nutritious and balanced diet ' +
						'to help ensure <%= dogPronounHeShe %> gets all the nutrients <%= dogPronounHeShe %> needs to remain healthy.</p>'
				},
				moderate: {
					minimumRiskScore: 20,
					display: 'Moderate Risk',
					productRecommendation: 'Glyde only',
					message: '<p>Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHeShe %> has a low risk for OA because of one of the following factors: ' +
						'older age, breed, overweight, history of joint problems.</p>' +
						'<p>It is recommended you consider starting <%= dogName %> on a joint health program which includes Glyde® Mobility Chews.</p>' +
						'<p>Please talk to your veterinarian about Glyde® and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA.</p>'
				},
				elevated: {
					minimumRiskScore: 25,
					display: 'Elevated Risk',
					productRecommendation: 'Glyde plus Zydax',
					message: '<p>Based on <%= dogName %>\'s current  profile, it appears that <%= dogPronounHeShe %> has a moderate need to address OA.</p>' +
						'<p>It is recommended you consider starting <%= dogName %> on a joint health program which includes:</p>' +
						'<ol>' +
						'<li>Glyde® Mobility Chews</li>' +
						'<li>A disease modifying OA drug, or DMOAD</li>' +
						'</ol>' +
						'<p>DMOADs are prescription drugs that slow the process of OA.</p>' +
						'<p>Please talk to your veterinarian about these treatments and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA.</p>'
				},
				significant: {
					minimumRiskScore: 45,
					display: 'Significant Risk',
					productRecommendation: 'Glyde, Zydax plus NSAID',
					message: '<p>Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHeShe %> has a significant need to address OA. ' +
						'It is recommended you consider starting <%= dogName %> on a joint health program which includes:</p>' +
						'<ol>' +
						'<li>Glyde® Mobility Chews</li>' +
						'<li>A disease modifying OA drug, or DMOAD</li>' +
						'<li>A non-steroidal anti-inflammatory drug (NSAID) for dogs</li>' +
						'</ol>' +
						'<p>DMOADs are prescription drugs that slow the process of OA.</p>' +
						'<p>NSAIDs are medications that reduce swelling and pain caused by OA. </p>' +
						'<p>Please talk to your veterinarian about these treatments and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA. ' +
						'(NSAIDs, or pain relievers, for people should NEVER be given to a dog.)</p>'
				}
			},
			AUS: {
				none: {
					minimumRiskScore: 0,
					display: 'No Risk',
					productRecommendation: 'no recommendation at this time',
					message: '<p>Good news! Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHisHer %> joint health is fine. ' +
						'Let\'s keep it that way! Make sure <%= dogPronounHeShe %> eats a nutritious and balanced diet ' +
						'to help ensure <%= dogPronounHeShe %> gets all the nutrients <%= dogPronounHeShe %> needs to remain healthy.</p>'
				},
				moderate: {
					minimumRiskScore: 20,
					display: 'Moderate Risk',
					productRecommendation: 'Glyde only',
					message: '<p>Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHeShe %> has a low risk for OA because of one of the following factors: ' +
						'older age, breed, overweight, history of joint problems.</p>' +
						'<p>It is recommended you consider starting <%= dogName %> on a joint health program which includes Glyde® Mobility Chews.</p>' +
						'<p>Please talk to your veterinarian about Glyde® and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA.</p>'
				},
				elevated: {
					minimumRiskScore: 25,
					display: 'Elevated Risk',
					productRecommendation: 'Glyde plus Zydax',
					message: '<p>Based on <%= dogName %>\'s current  profile, it appears that <%= dogPronounHeShe %> has a moderate need to address OA.</p>' +
						'<p>It is recommended you consider starting <%= dogName %> on a joint health program which includes Glyde® and Zydax®.</p>' +
						'<ol>' +
						'<li>Glyde® Mobility Chews offer a proven alternative that not only control the signs of OA, but also aid in the improvement of ' +
						'joint health & function in dogs.</li>' +
						'<li>Zydax is a disease modifying osteoarthritis drug that is clinically proven to improve mobility in dogs in 28 days.</li>' +
						'</ol>' +
						'<p>Please talk to your veterinarian about these treatments and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA.</p>'
				},
				significant: {
					minimumRiskScore: 45,
					display: 'Significant Risk',
					productRecommendation: 'Glyde, Zydax plus NSAID',
					message: '<p>Based on <%= dogName %>\'s current profile, it appears that <%= dogPronounHeShe %> has a significant need to address OA. ' +
						'It is recommended you consider starting <%= dogName %> on a joint health program which includes Glyde®, Zydax®, and a non-steroidal ' +
						'anti-inflammatory drug (NSAID) for dogs.</p>' +
						'<ol>' +
						'<li>Glyde® Mobility Chews offer a proven alternative that not only control the signs of OA, but also aid in the improvement of ' +
						'joint health & function in dogs.</li>' +
						'<li>Zydax is a disease modifying osteoarthritis drug that is clinically proven to improve mobility in dogs in 28 days.</li>' +
						'<li>NSAIDs are medications that reduce swelling and pain caused by OA.</li>' +
						'</ol>' +
						'<p>Please talk to your veterinarian about these treatments and other lifestyle options that may also help keep <%= dogPronounHimHer %> moving and protected against OA. ' +
						'(NSAIDs, or pain relievers, for people should NEVER be given to a dog.)</p>'
				}
			}
		}
	};
})();
